import { Grid } from '@mui/material'
import makeStyles from '@mui/styles/makeStyles'
import Typography from '@mui/material/Typography'
import ChipCategory from 'components/ChipCategory'
import ChipStation from 'components/ChipStation'
import { CDN_SHOWS_BASEURL, replaceUmlauts } from 'lib/utils'

const useStyles = makeStyles((theme) => ({
  header: {
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3),
    color: 'white',
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%'
  },
  title: {
    marginBottom: theme.spacing(2)
  },
  chips: {
    marginBottom: theme.spacing(2)
  },
  imageContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    '@media (max-width: 767px)': {
      display: 'none'
    }
  },
  image: {
    maskImage: 'linear-gradient(to right, transparent 0%, black 20%)',
    '-webkit-mask-image': 'linear-gradient(to right, transparent 0%, black 10%)',
    objectFit: 'fill'
  },
  imageMobile: {
    display: 'flex',
    marginBottom: theme.spacing(2),
    justifyContent: 'flex-end',
    '@media (min-width: 768px)': {
      display: 'none'
    }
  }
}))

export default function SeriesDetails ({ series }) {
  const classes = useStyles()

  if (series.description) {
    const img = CDN_SHOWS_BASEURL + '/series/' + replaceUmlauts(series.slug) + '.jpg'
    return (
      <div className={classes.header}>
        <div className={classes.textContainer}>
          <Typography component='h1' variant='h1' className={classes.title} dangerouslySetInnerHTML={{ __html: series.name }} />
          <img src={img} alt={series.name} title={series.name} className={classes.imageMobile} width={300} height={169} />
          <div className={classes.chips}>
            <ChipStation name={series.stations[0].name} slug={series.stations[0].slug} />
            <ChipCategory name={series.categories[0].name} slug={series.categories[0].slug} />
          </div>
          <Typography gutterBottom variant='body1' component='div' dangerouslySetInnerHTML={{ __html: series.description }} />
        </div>
        <div className={classes.imageContainer}>
          <img src={img} alt={series.name} title={series.name} className={classes.image} width={300} height={169} />
        </div>
      </div>
    )
  } else {
    return (
      <Grid container className={classes.header}>
        <Typography component='h1' variant='h1' dangerouslySetInnerHTML={{ __html: series.name }} />
      </Grid>
    )
  }
}
